export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div
      data-testid="auth-layout"
      className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4 py-10"
    >
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="w-9 h-9 rounded-lg bg-teal-600 flex items-center justify-center text-white font-bold">D</div>
            <span className="text-lg font-semibold text-slate-900">Dental OS</span>
          </div>
          <h1
            data-testid="auth-title"
            className="text-2xl font-bold text-slate-900"
          >{title}</h1>
          {subtitle ? (
            <p data-testid="auth-subtitle" className="mt-2 text-sm text-slate-500">{subtitle}</p>
          ) : null}
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8">
          {children}
        </div>
        {footer ? <div className="mt-6 text-center text-sm text-slate-500">{footer}</div> : null}
      </div>
    </div>
  );
}
